export default "__VITE_ASSET__DCkKIXJA__"